<div class="systembar-help_help-wrapper" [matMenuTriggerFor]="helpMenu" (menuOpened)="isMenuOpen.set(true)" (menuClosed)="isMenuOpen.set(false)">
  <div class="systembar-help_help-logo">
    <celum-icon [configuration]="iconConfiguration"></celum-icon>
  </div>
</div>
<mat-menu #helpMenu="matMenu" class="systembar-help_mat-menu" yPosition="above">
  @for (item of contextMenuItems; track item.text) {
    <button mat-menu-item (click)="item.onClick()" [attr.data-component-id]="item.dataComponentId">
      {{ item.text | translate }}
    </button>
  }
</mat-menu>
